var React = require('react');

function Dash (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#ED2246","strokeWidth":"1.5"},React.createElement("g",{"transform":"translate(-558 -2113) translate(559 2114)"},[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M21.23 18.462c5.845 0 9.469 1.776 10.873 5.327l-4.759 4.958-4.594-4.785-10.285 10.714H9.692v-6.984c0-6.154 3.846-9.23 11.539-9.23z","key":0}),React.createElement("circle",{"cx":"21.231","cy":"5.769","r":"5.769","key":1}),React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M0 34.676L12.465 34.676 22.75 23.962 27.344 28.747 44.308 11.077M44.769 11.077L44.769 19.385M44.308 11.077L36 11.077","key":2})]))));
}

Dash.defaultProps = {"width":"47","height":"37","viewBox":"0 0 47 37"};

module.exports = Dash;

Dash.default = Dash;
